import WidgetsShow from "../components/widgets/Show";

export default [
  { name: 'Widgets', path: '/widgets', component: WidgetsShow,  }
]
